import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { removeFormErrors } from "store/form/actions";

import { useOutsideClickHook } from "utils/outsideClick";
import { useStateSelector } from "utils/field";

import DropDown from "components/Dropdown";
import Dialog, { CloseDialog } from "components/Dialog";
import Button from "components/Button";

import classes from "./style.module.scss";

import Delete from "assets/images/icons/JSX/Delete";

export default React.memo(({ formName, accessor, change, isUpgrade = false }) => {
    const dispatch = useDispatch();

    const [menuOpen, toggleMenuOpen] = useState(false);
    const [deleteDialogOpen, toggleDeleteDialog] = useState(false);

    const ref = useOutsideClickHook(() => toggleMenuOpen(false));

    // accessor is either "model.modelData.generation.pvSystems.{id}" or "newForm.upgradeDrawer.fields.pvSystems.{id}"
    const isUpgradeContext = accessor.startsWith("newForm.upgradeDrawer.fields");
    const systemsAccessor = isUpgradeContext
        ? "newForm.upgradeDrawer.fields.pvSystems"
        : "model.modelData.generation.pvSystems";

    const pvSystems = useStateSelector(systemsAccessor) || {};

    const handleDelete = () => {
        const filteredPvSystems = Object.entries(pvSystems).reduce((acc, [key, value]) => {
            if (key === accessor.split("pvSystems.")[1]) {
                return acc;
            }
            return {
                ...acc,
                [key]: value,
            };
        }, {});

        change(systemsAccessor, filteredPvSystems);
        dispatch(removeFormErrors(systemsAccessor));
    };

    return (
        <div className={classes.actions} ref={ref}>
            <div className={classes.menu}>
                <div className={classes.dots} onClick={() => toggleMenuOpen(!menuOpen)}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <DropDown
                    className={classes.dropDown}
                    open={menuOpen}
                    toggleOpen={toggleMenuOpen}
                    options={[
                        {
                            label: (
                                <span>
                                    <Delete /> Delete
                                </span>
                            ),
                            className: classes.delete,
                            onClick: () => toggleDeleteDialog(true),
                        },
                    ]}
                />
            </div>
            <Dialog open={deleteDialogOpen}>
                <CloseDialog closeActions={() => toggleDeleteDialog(false)} />
                <div className={classes.dialog}>
                    <h3>Are you sure you want to delete this solar PV system?</h3>
                    <div className={classes.footer}>
                        <Button type="hollow" onClick={() => toggleDeleteDialog(false)}>
                            Cancel
                        </Button>
                        <Button onClick={() => handleDelete()} type="red">
                            Delete
                        </Button>
                    </div>
                </div>
            </Dialog>
        </div>
    );
});
